module.exports = __webpack_public_path__ + "images/onboarding-banner/atlassian-setup-complete.888ef31c706220083e69.png";